<template lang="pug">
    .login
        Layout
            Content.loginContent(:style="loginPageContentStyle")
                div(:style="backgroundLogoStyle")
                    Card.loginCard(dis-hover)
                        img(src="" v-real-img="loginImgs.loginFormLogoImgName" style="min-width:300px;max-width: 350px;margin: 10px 0 ")
                        Divider(v-if="loginDescription!== ''")
                        p.loginDescription(v-if="loginDescription!== ''") {{ loginDescription }}
                        //- .loginDescriptionBlock(v-else)
                        Form.loginInput(
                            ref="loginForm",
                            :model="loginForm",
                            :rules="loginRules"
                        )
                            FormItem(prop="username")
                                Input(
                                    @on-enter="handleSubmit"
                                    type="text"
                                    v-model="loginForm.username"
                                    placeholder="Username"
                                    suffix="md-person"
                                    id="username"
                                )
                            FormItem(prop="password")
                                Input(
                                    @on-enter="handleSubmit"
                                    type="password"
                                    password
                                    v-model="loginForm.password"
                                    placeholder="Password"
                                    id="password"
                                )
                            FormItem(prop="otpToken")
                                Input.otpInput(
                                    @on-enter="handleSubmit"
                                    v-model="loginForm.otpToken"
                                    placeholder="Token"
                                    suffix="md-key"
                                )
                            FormItem
                                Button.loginBtn( @click="handleSubmit") Login
</template>
<script>
import { _login } from "@/api/user";
import { getUserData } from "@/api/user";
import { getPlatformPlan } from "@/api/system";
import { _getCusInvoices } from "@/api/billing";

export default {
    name: "Login",
    data() {
        return {
            loginForm: {
                username: "",
                password: "",
                otpToken: "",
            },
            loginRules: {
                username: [
                    {
                        required: true,
                        message: "Please fill in the user name",
                        trigger: "change",
                    },
                ],
                password: [
                    {
                        required: true,
                        message: "Please fill in the password.",
                        trigger: "change",
                    },
                ],
                otpToken: [
                    {
                        required: true,
                        message: "Please fill in the token.",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    created() {},
    methods: {
        handleSubmit() {
            this.$refs.loginForm.validate((valid) => {
                if (!valid) return;
                this.login();
            });
        },
        async login(e) {
            try {
                await _login(this.loginForm);

                let userDataResult = await getUserData();
                let userData = userDataResult.data;
                this.$store.commit("SET_USER_DATA", userData);
                // 獲取平台限制
                await getPlatformPlan({ groupName: this.$store.state.queryGroupName })
                    .then((res) => {
                        this.$store.commit("SET_PLATFORM_PLAN", res.data);
                    })
                    .catch((err) => {
                        console.log(err);
                    });

                try {
                    if (this.$store.state.platformPlan.multiTenancyConfigs.isAllowPaymentShow) {
                        let getCusInvoicesResult = await _getCusInvoices({
                            groupName: this.$store.state.queryGroupName,
                            customerId: undefined,
                        });
                        let overdraftInvoice = getCusInvoicesResult.data.data.invoice.find((e) => e.status == "open");
                        //有金流權限並且有給groupName而且有欠款
                        if (overdraftInvoice)
                            return this.$router.push({
                                path: "/account-info/payment",
                                query: { groupName: this.$store.state.queryGroupName },
                            });
                    }
                } catch (err) {
                    console.log("Login>>", err);
                    //     this.$Notice.warning({
                    //         title: this.$i18n.t("global.error"),
                    //         desc: `${err.data.message}`,
                    //     });
                }
                this.$router.push({ path: this.$store.getters.landingPagePath });
            } catch (err) {
                console.log(err);
                this.$Message.error("帳號或密碼有誤");
                // let errMessage = err.data;
                // this.$Message.error(errMessage);
            }
        },
    },
    computed: {
        loginDescription: function () {
            return this.$store.getters.getLoginDescription;
        },
        loginImgs: function () {
            return this.$store.getters.getLoginPageImgs;
        },
        loginPageContentStyle() {
            return {
                background: `url(${this.loginImgs.backgroundImgName}) no-repeat center center`,
                overflow: "hidden",
                "background-size": "cover",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
                "background-color": this.loginImgs.backgroundImgName ? `none` : `#101820`,
            };
        },
        backgroundLogoStyle() {
            return {
                width: "100vw",
                height: "100vh",
                background: `url(${this.loginImgs.backgroundLogoImgName}) no-repeat center center`,
                "background-size": "auto 90%",
                display: "flex",
                "justify-content": "center",
                "align-items": "center",
            };
        },
    },
};
</script>
<style scoped>
.loginFormLogoImgBlock {
    width: 350px;
    height: 80px;
    background: grey;
}
.loginCard {
    background: transparent;
    border: none;
    text-align: center;
}
.ivu-input-wrapper >>> .ivu-input-suffix {
    padding-right: 15px;
}

.ivu-input-wrapper >>> .ivu-input-suffix i {
    line-height: 40px;
}
.loginDescription {
    font-size: 28px;
    color: #fff;
    margin-bottom: 24px;
}
.loginDescriptionBlock {
    width: 350px;
    height: 40px;
    background: grey;
    margin-bottom: 24px;
}
@media screen and (min-width: 1280px) {
    .login-description {
        font-size: 28px;
    }
}
@media (max-width: 1080px) and (min-width: 960px) {
    .login-description {
        font-size: 24px;
    }
}
@media screen and (max-width: 960px) {
    .login-description {
        font-size: 20px;
    }
}
</style>



// WEBPACK FOOTER //
// src/view/general/Login.vue